import { useState, useEffect } from 'react';
import api from '../../../services/api';
import './AdminSlider.css';

const STATUS_LABELS = { open: 'Açık', 'in-progress': 'İşlemde', waiting: 'Bekliyor', resolved: 'Çözüldü', closed: 'Kapalı' };
const PRIORITY_LABELS = { low: 'Düşük', medium: 'Orta', high: 'Yüksek', urgent: 'Acil' };
const CATEGORY_LABELS = { technical: 'Teknik', account: 'Hesap', content: 'İçerik', feature: 'Özellik', other: 'Diğer' };

const AdminTickets = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [viewingTicket, setViewingTicket] = useState(null);
  const [replyMessage, setReplyMessage] = useState('');

  useEffect(() => { fetchTickets(); }, []);

  const fetchTickets = async () => {
    try { setLoading(true); const res = await api.get('/api/tickets/admin/all'); setTickets(res.data); }
    catch { setError('Ticketlar yüklenemedi.'); }
    finally { setLoading(false); }
  };

  const handleView = async (id) => {
    try { const res = await api.get(`/api/tickets/${id}`); setViewingTicket(res.data); }
    catch { setError('Ticket yüklenemedi.'); }
  };

  const handleReply = async (e) => {
    e.preventDefault();
    if (!replyMessage) return;
    try {
      const res = await api.post(`/api/tickets/${viewingTicket._id}/reply`, { message: replyMessage });
      setViewingTicket(res.data);
      setReplyMessage('');
    } catch { setError('Gönderilemedi.'); }
  };

  const handleStatusChange = async (id, status) => {
    try { await api.put(`/api/tickets/${id}/status`, { status }); setSuccess('Durum güncellendi.'); fetchTickets(); if (viewingTicket?._id === id) handleView(id); }
    catch { setError('Güncelleme başarısız.'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Ticket silinsin mi?')) return;
    try { await api.delete(`/api/tickets/${id}`); setSuccess('Silindi.'); setViewingTicket(null); fetchTickets(); }
    catch { setError('Silinemedi.'); }
  };

  if (loading) return <div className="admin-slider-empty">Yükleniyor...</div>;

  // Detay görünümü
  if (viewingTicket) {
    return (
      <div className="admin-slider">
        {error && <div className="admin-slider-error">{error}</div>}
        <button onClick={() => setViewingTicket(null)} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: 'none', border: 'none', color: '#60a5fa', cursor: 'pointer', fontSize: '0.85rem', marginBottom: '1rem' }}>← Listeye Dön</button>

        <div className="admin-slider-card">
          <div className="admin-slider-header">
            <h3>{viewingTicket.subject}</h3>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <select value={viewingTicket.status} onChange={(e) => handleStatusChange(viewingTicket._id, e.target.value)} style={{ padding: '0.3rem 0.5rem', backgroundColor: '#374151', border: '1px solid #4b5563', borderRadius: '0.25rem', color: '#fff', fontSize: '0.75rem' }}>
                <option value="open">Açık</option>
                <option value="in-progress">İşlemde</option>
                <option value="waiting">Bekliyor</option>
                <option value="resolved">Çözüldü</option>
                <option value="closed">Kapalı</option>
              </select>
              <button onClick={() => handleDelete(viewingTicket._id)} style={{ background: 'none', border: '1px solid #374151', color: '#f87171', padding: '0.3rem 0.5rem', borderRadius: '0.25rem', cursor: 'pointer', fontSize: '0.7rem' }}>Sil</button>
            </div>
          </div>
          <div style={{ padding: '0.75rem 1.5rem', borderBottom: '1px solid #374151', fontSize: '0.8rem', color: '#9ca3af' }}>
            {viewingTicket.ticketNumber} • {viewingTicket.user?.username} ({viewingTicket.user?.email}) • {CATEGORY_LABELS[viewingTicket.category]} • {PRIORITY_LABELS[viewingTicket.priority]}
          </div>

          {/* Mesajlar */}
          <div style={{ padding: '1rem 1.5rem', display: 'flex', flexDirection: 'column', gap: '0.75rem', maxHeight: '400px', overflowY: 'auto' }}>
            {viewingTicket.messages?.map((msg, i) => (
              <div key={i} style={{ padding: '0.75rem', borderRadius: '0.5rem', backgroundColor: msg.senderRole === 'admin' ? '#1e3a5f' : '#374151', borderLeft: msg.senderRole === 'admin' ? '3px solid #3b82f6' : '3px solid #4b5563' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                  <span style={{ fontSize: '0.75rem', fontWeight: '600', color: msg.senderRole === 'admin' ? '#60a5fa' : '#d1d5db' }}>{msg.sender?.username} {msg.senderRole === 'admin' && '(Admin)'}</span>
                  <span style={{ fontSize: '0.65rem', color: '#6b7280' }}>{new Date(msg.createdAt).toLocaleString('tr-TR')}</span>
                </div>
                <p style={{ color: '#e2e8f0', fontSize: '0.85rem', margin: 0, whiteSpace: 'pre-wrap' }}>{msg.message}</p>
              </div>
            ))}
          </div>

          {/* Admin Yanıt */}
          {viewingTicket.status !== 'closed' && (
            <form onSubmit={handleReply} style={{ padding: '1rem 1.5rem', borderTop: '1px solid #374151', display: 'flex', gap: '0.5rem' }}>
              <textarea value={replyMessage} onChange={(e) => setReplyMessage(e.target.value)} placeholder="Yanıt yazın..." rows="2" style={{ flex: 1, padding: '0.5rem', backgroundColor: '#374151', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff', fontSize: '0.85rem', resize: 'vertical' }} required />
              <button type="submit" className="admin-slider-add-btn" style={{ alignSelf: 'flex-end' }}>Yanıtla</button>
            </form>
          )}
        </div>
      </div>
    );
  }

  // Liste görünümü
  const openCount = tickets.filter(t => t.status === 'open').length;

  return (
    <div className="admin-slider">
      {success && <div className="admin-slider-success">{success}</div>}
      {error && <div className="admin-slider-error">{error}</div>}

      <div className="admin-slider-card">
        <div className="admin-slider-header">
          <h3>Destek Talepleri ({tickets.length}) {openCount > 0 && <span style={{ color: '#60a5fa', fontSize: '0.8rem' }}>({openCount} açık)</span>}</h3>
        </div>

        {tickets.length > 0 ? (
          <div style={{ padding: '1rem 1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {tickets.map(t => (
              <div key={t._id} onClick={() => handleView(t._id)} style={{ padding: '0.75rem 1rem', backgroundColor: '#374151', borderRadius: '0.5rem', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderLeft: t.status === 'open' ? '3px solid #3b82f6' : t.status === 'closed' ? '3px solid #6b7280' : '3px solid #f59e0b' }}>
                <div>
                  <strong style={{ color: '#f3f4f6', fontSize: '0.85rem' }}>{t.subject}</strong>
                  <p style={{ color: '#9ca3af', fontSize: '0.7rem', margin: '0.2rem 0 0 0' }}>{t.ticketNumber} • {t.user?.username} • {PRIORITY_LABELS[t.priority]} • {new Date(t.updatedAt).toLocaleDateString('tr-TR')}</p>
                </div>
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                  {t.lastReplyBy === 'user' && t.status !== 'closed' && <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#3b82f6' }} title="Kullanıcı yanıtı bekliyor" />}
                  <span style={{ fontSize: '0.65rem', padding: '0.15rem 0.4rem', borderRadius: '9999px', backgroundColor: t.status === 'open' ? 'rgba(59,130,246,0.15)' : t.status === 'closed' ? 'rgba(107,114,128,0.15)' : 'rgba(245,158,11,0.15)', color: t.status === 'open' ? '#60a5fa' : t.status === 'closed' ? '#9ca3af' : '#fbbf24' }}>{STATUS_LABELS[t.status]}</span>
                </div>
              </div>
            ))}
          </div>
        ) : <div className="admin-slider-empty">Henüz destek talebi yok.</div>}
      </div>
    </div>
  );
};

export default AdminTickets;
